import { useState } from "react";
import { faqItems, tipItems } from "@/mocks/gossipGuide";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div>
          <p className="text-sm font-semibold uppercase tracking-wide text-accent-600">常见问题</p>
          <h2 className="mt-2 text-3xl text-foreground-950 md:text-4xl">投稿前都想问的几件事</h2>
          <p className="mt-3 max-w-md text-foreground-600">
            吃瓜投稿能不能赚、单价怎么算、多久结算、提现怎么走，这些高频问题一次说清。
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((f, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200"
              >
                <button
                  className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-foreground-950">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    <i className="ri-add-line" aria-hidden="true"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="mx-auto mt-16 w-full max-w-7xl px-4 md:px-6">
        <div className="flex items-center gap-2">
          <span className="h-6 w-1.5 rounded-full bg-primary-500" aria-hidden="true"></span>
          <h3 className="text-2xl text-foreground-950 md:text-3xl">投稿提现避坑清单</h3>
        </div>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {tipItems.map((t) => (
            <div key={t.title} className="rounded-2xl bg-background-50 p-6 ring-1 ring-background-200">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-xl text-primary-600">
                <i className={t.icon} aria-hidden="true"></i>
              </span>
              <h4 className="mt-4 font-semibold text-foreground-950">{t.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}